export default __webpack_public_path__ + "static/media/HoneyMustardChicken.7bd54ac7.jpg";